import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpClient, HttpParams, HttpHeaders, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { GithubApi, AccountOffice, AccountOfficeObject, UserListObject, UserLevel, UserStatus, UserCountry, UserDetail } from '../models/administration.model';
import { catchError, retry } from 'rxjs/operators';

@Injectable()
export class AdministrationService {
    private warrantServiceURL: string = environment.WMS_Service_URL;

    constructor(private httpclient: HttpClient) { }

    /** An example database that the data source uses to retrieve data for the table. */
    getRepoIssues(sort: string, order: string, page: number): Observable<GithubApi> {
        const href = 'https://api.github.com/search/issues';
        const requestUrl =
            `${href}?q=repo:angular/material2&sort=${sort}&order=${order}&page=${page + 1}`;

        return this.httpclient.get<GithubApi>(requestUrl);
    }

    getAccountOfficeList(model: AccountOffice): Observable<AccountOfficeObject> {
        let url = this.warrantServiceURL + "api/AdministrationManager/GetNgrAccountOfficeList";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post<AccountOfficeObject>(url, model, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getInitUserList(): Observable<UserListObject> {
        let url = this.warrantServiceURL + "api/AdministrationManager/GetInitUserList";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.get<UserListObject>(url, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getUserList(model: any): Observable<UserListObject> {
        let url = this.warrantServiceURL + "api/AdministrationManager/GetUserList";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post<UserListObject>(url, model, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getUserLevels(): Observable<UserLevel[]> {
        let url = this.warrantServiceURL + "api/AdministrationManager/GetUserLevels";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.get<UserLevel[]>(url, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getUserCountries(): Observable<UserCountry[]> {
        let url = this.warrantServiceURL + "api/AdministrationManager/GetUserCountries";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.get<UserCountry[]>(url, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getUserStatus(): Observable<UserStatus[]> {
        let url = this.warrantServiceURL + "api/AdministrationManager/GetUserStatus";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.get<UserStatus[]>(url, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getIsAdUserByAccountName(model: string): Observable<HttpResponse<boolean>> {
        let url = this.warrantServiceURL + "api/AdministrationManager/GetIsAdUserByAccountName";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.get<HttpResponse<boolean>>(url, {
            headers: header,
            observe: 'response',
            params: new HttpParams()
                .set('userId', model)
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    addUserDetail(model: UserDetail): Observable<HttpResponse<number>> {
        let url = this.warrantServiceURL + "api/AdministrationManager/AddNewUserDetail";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post<HttpResponse<number>>(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    othAddAccOff(model: any): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/AdministrationManager/Oth_AddAccountOffice";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    othUpdateAccOff(model: any): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/AdministrationManager/Oth_UpdateAccountOffice";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    ngrAddAccOff(model: any): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/AdministrationManager/NGR_AddAccountOffice";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    ngrUpdateAccOff(model: any): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/AdministrationManager/NGR_UpdateAccountOffice";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    addFareDetails(model: any): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/AdministrationManager/AddFareDetails";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    updateFareDetails(model: any): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/AdministrationManager/UpdateFareDetails";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    addFareTaxObjIdList(model: any): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/AdministrationManager/AddFareTaxDetails";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    updateFareTaxDetails(model: any): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/AdministrationManager/UpdateFareTaxDetails";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getNewScreenCode(): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/AdministrationManager/GetNewScreenCode";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.get(url, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    addNewUserLevel(model: any): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/AdministrationManager/AddNewUserLevel";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getUserLevelScreenCode(model: any): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/AdministrationManager/GetUserLevelScreenCode";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    updateUserLevelDetails(model: any): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/AdministrationManager/UpdateUserLevelDetails";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getInitFareList(): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/AdministrationManager/GetInitFareList";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.get(url, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getFareList(model: any): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/AdministrationManager/GetFareList";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    deleteFareTaxDetails(model: any): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/AdministrationManager/DeleteFareTaxDetails";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getFareTaxList(model: any): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/AdministrationManager/GetFareTaxList";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getUserLevelDetails(model: any): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/AdministrationManager/GetUserLevelDetails";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getUserLevelList(): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/AdministrationManager/GetUserLevelList";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.get(url, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getOthAccountOfficeList(model: any): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/AdministrationManager/GetOthAccountOfficeList";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    othDeleteAccOff(model: any): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/AdministrationManager/Oth_DeleteAccountOffice";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getSwkAccountOfficeList(model: any): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/AdministrationManager/GetSwkAccountOfficeList";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    swkUpdateAccOff(model: any): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/AdministrationManager/Swk_UpdateAccountOffice";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getNgrAccountOfficeList(model: any): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/AdministrationManager/GetNgrAccountOfficeList";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    ngrDeleteAccOff(model: any): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/AdministrationManager/NGR_DeleteAccountOffice";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    private handleError(error: Response | any): Observable<any> {
        // In a real world app, we might use a remote logging infrastructure
        if (error instanceof Response) {
            // const body = error.json() || '';
            // const err = body.error || JSON.stringify(body);
            // errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
            console.error(error);
            return Observable.throw(error);
        } else {
            let errMsg: string;
            errMsg = error.message ? error.message : error.toString();
            console.error(errMsg);
            return Observable.throw(errMsg);
        }
    }
}